import { render, staticRenderFns } from "./QuestionInputDropDown.vue?vue&type=template&id=637b5589&"
import script from "./QuestionInputDropDown.vue?vue&type=script&lang=ts&"
export * from "./QuestionInputDropDown.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports